import { useEffect, useRef, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../Icon';

export function WikiSearch() {
  const [query, setQuery] = useState('');
  const input = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const shortcut = (event: KeyboardEvent) => {
      if (event.key !== '/' || event.ctrlKey || event.metaKey || event.altKey) return;
      if (
        event.target instanceof HTMLElement &&
        (event.target.matches('input, textarea, select') || event.target.isContentEditable)
      )
        return;
      event.preventDefault();
      input.current?.focus();
    };
    document.addEventListener('keydown', shortcut);
    return () => document.removeEventListener('keydown', shortcut);
  }, []);
  const submit = (event: FormEvent) => {
    event.preventDefault();
    navigate(`/explore${query.trim() ? `?q=${encodeURIComponent(query.trim())}` : ''}`);
  };
  return (
    <form className="workspace-search" role="search" onSubmit={submit}>
      <Icon name="search" />
      <label className="sr-only" htmlFor="site-search">
        Search public wikis
      </label>
      <input
        id="site-search"
        ref={input}
        placeholder="Search public wikis…"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      <kbd>/</kbd>
    </form>
  );
}
